module.exports = __webpack_public_path__ + "media/images/footer-bk-30cccb8678efe6ea06f88f4e2215758c.jpg";